// ABOUTME: The previous and next arrows beside one cloud of the stack, drawn on the stack canvas at the tier's height.
// ABOUTME: Positioned above every cloud (z 7, pointer events on) so the clouds never paint over or swallow a press.

import { useState } from 'react';
import { Box, IconButton } from '@mui/material';
import { CROSSING_GROUND, CROSSING_ARROW_BORDER, CROSSING_ARROW_INK } from '../../../../theme/crossingTokens';
import { STACK_CANVAS } from './stackGeometry';

interface TierArrowsProps {
  // Canvas y of the tier's vertical centre.
  centerY: number;
  onPrev: () => void;
  onNext: () => void;
  prevLabel: string;
  nextLabel: string;
  // The arrows fade in only when they mount with this set. It is read once at mount, so a re-render keeps the same
  // animation on the same nodes and a stack that has not yet painted never fades.
  fadeIn?: boolean;
}

const ARROW_SIZE = 40;
const EDGE_GAP = 4;

const arrowSx = {
  position: 'absolute', zIndex: 7, pointerEvents: 'auto',
  width: ARROW_SIZE, height: ARROW_SIZE, borderRadius: '999px', border: `1px solid ${CROSSING_ARROW_BORDER}`,
  backgroundColor: CROSSING_GROUND, color: CROSSING_ARROW_INK, fontSize: '18px',
  '&:hover': { backgroundColor: CROSSING_GROUND },
} as const;

const ARROW_FADE = {
  '@keyframes tierArrowsFadeIn': { from: { opacity: 0 }, to: { opacity: 1 } },
  animation: 'tierArrowsFadeIn 0.55s ease 0.5s both',
} as const;

export default function TierArrows({ centerY, onPrev, onNext, prevLabel, nextLabel, fadeIn }: TierArrowsProps) {
  const [fade] = useState(!!fadeIn);
  const top = centerY - ARROW_SIZE / 2;
  return (
    <Box sx={{ display: 'contents' }}>
      <IconButton aria-label={prevLabel} onClick={onPrev} sx={{ ...arrowSx, ...(fade ? ARROW_FADE : {}), top, left: EDGE_GAP }}>&#8249;</IconButton>
      <IconButton aria-label={nextLabel} onClick={onNext} sx={{ ...arrowSx, ...(fade ? ARROW_FADE : {}), top, left: STACK_CANVAS.width - ARROW_SIZE - EDGE_GAP }}>&#8250;</IconButton>
    </Box>
  );
}
